import PodcastIframe from "@/components/PodcastIframe.tsx";
import {HeroHeader} from "@/components/HeroHeader.tsx";
import {MetaTags} from "@/hooks/MetaTags.tsx";

const IFRAME_SRC = "https://iframe.iono.fm/chan/9375?layout=modern";

export default function ListenNewsPage() {
    return (
        <>
            <MetaTags
                title={"Kosmos 94.1 - Luister"}
                description={"Bulletin misgeloop? Luister hier."}
                url={"/nuus/luister"}
            />

            <HeroHeader
                title="Luister"
                subtitle="Bulletin misgeloop? Luister hier."
                imageAlt="luister"
            />

            <PodcastIframe
                src={IFRAME_SRC}
            />
        </>
    );
}